import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faEdit,
  faTrash,
  faBookmark,
  faWrench,
  faLock,
  faFileDownload
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import truncateString from "../../utils/truncateString";
import {
  Button,
  ButtonToolbar,
  DropdownButton,
  Dropdown,
  OverlayTrigger
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ButtonShareWithRecipient from "../ButtonShareWithRecipient";
import DeleteConfirmForm from "../settings/DeleteConfirmForm";
import UploadModalContent from "./UploadModalContent";
import UpdateItemTagsForm from "./UpdateItemTagsForm";
import {
  setItem,
  upvoteItem,
  deleteUpvoteItem,
  favoriteItem,
  deleteFavoriteItem,
  addTagToItem,
  removeTagFromItem,
  updateTagsForItems
} from "../../actions/items";
import { addContentTagSuccess } from '../../actions/settings';
import { copyToClipboard } from "../../utils/common";
import { getSimpleIconByName } from "../../assets/icons";
import iconUpvoteFilled from "../../assets/images/icon-upvote-filled.svg";
import iconUpvoteOutlined from "../../assets/images/icon-upvote-outline.svg";
import iconFavoriteFilled from "../../assets/images/icon-sq-24-star-filled.svg";
import iconFavoriteOutlined from "../../assets/images/icon-sq-24-star-outline.svg";
import { addEventNameToEndpoint } from "../../utils/common";
import { ShareType } from "../../constants/Types";
import "./HozizontalItemCard.scss";

const ReactSwal = withReactContent(Swal);

const renderTooltip = (props, key) => (
  <div
    {...props}
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      padding: '2px 10px',
      color: 'white',
      borderRadius: 3,
      ...props.style,
    }}
  >
    {key}
  </div>
);

class HorizontalItemCard extends Component {
  handleGotoDetail = (e) => {
    const { data, history, onClick } = this.props;
    e.stopPropagation();

    if (e.shiftKey) {
      if (onClick) {
        onClick(data.id);
      }
      return;
    }

    this.props.setItem(data.id);
    history.push(`/item/detail/${data.id}`, {
      id: data.id,
      data
    });
  }

  handleDeleteItem = async () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type='item'
          data={this.props.data}
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        this.props.deleteItem(this.props.data.id);
      }
    });
  }

  onClickShare = (e) => {
    e.stopPropagation();

    addEventNameToEndpoint(this.props.Analytics, 'user-shorturl-copy');
    copyToClipboard(_.get(this.props, 'data.urls.short', ''));
  }

  handleUpvote = (e, id, isAddUpvote) => {
    e.stopPropagation();

    addEventNameToEndpoint(this.props.Analytics, isAddUpvote ? 'user-item-upvote' : 'user-item-unupvote');

    if (isAddUpvote) {
      this.props.upvoteItem(id);
    } else {
      this.props.deleteUpvoteItem(id);
    }
  }

  handleFavorite = (e, id, isFavorite) => {
    e.stopPropagation();

    addEventNameToEndpoint(this.props.Analytics, isFavorite ? 'user-item-unfavorite' : 'user-item-favorite');

    if (isFavorite) {
      this.props.deleteFavoriteItem(id);
    } else {
      this.props.favoriteItem(id);
    }
  }

  handleUpdateItem = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <UploadModalContent
        user={this.props.user}
        cognitoUser={this.props.cognitoUser}
        itemId={_.get(this.props.data, "id", null)}
        path={_.get(this.props.history, 'location.pathname', '')}
        onClose={ReactSwal.clickCancel}
        Auth={this.props.Auth}
        Analytics={this.props.Analytics}
      />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddTags = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: true,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <UpdateItemTagsForm
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
          itemData={this.props.data}
          cognitoUser={this.props.cognitoUser}
          Analytics={this.props.Analytics}
          contentTags={this.props.settings.contentTags}
          addContentTagSuccess={this.props.addContentTagSuccess}
          addTagToItem={this.props.addTagToItem}
          removeTagFromItem={this.props.removeTagFromItem}
          updateTagsForItems={this.props.updateTagsForItems}
          selectedItems={this.props.selectedItems}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleDragOver = e => {
    e.preventDefault();
    return false;
  }

  handleDragStart = e => {
    e.dataTransfer.setData("item", JSON.stringify(this.props.data));
  }
  
  render() {
    const { data } = this.props;

    // URLs
    // source: links only, then try SSL and fallback to target 
    const downloadUrl = _.get(this.props, 'data.urls.source', 
      _.get(this.props, 'data.urls.ssl', 
      _.get(this.props, 'data.urls.target', '')));

    // format the title
    const titleLong = _.get(data, 'meta.contentTitle', _.get(data, 'original.original_basename'));
    const titleShort = truncateString(titleLong, 50);
    const isFavorite = _.get(this.props, 'settings.userInfo.collectionFavorites', []).includes(data.id);
    const isAddUpvote = !_.get(this.props, 'settings.userInfo.collectionUpvotes', []).includes(data.id);
    const isShared = _.get(data, 'meta.isShared', true);
    const isAdmin = _.get(this.props, 'cognitoUser.attributes', {})['custom:role'] === 'admin';
    const isOwner = _.get(this.props, 'cognitoUser.username', '') === _.get(data, 'userId', '');

    return (
      <div className={`item-card-container horizontal btn ${isShared ? '' : 'locked'} ${this.props.isSelected ? 'selected-card' : ''}`}
        draggable={this.props.draggable || false}
        // onDrop={() => console.log('drop has happened')}
        // onDragEnd={() => console.log('item card drag end')}
        onDragStart={this.handleDragStart}
        onDragOver={this.handleDragOver}
      >
        <div className="details-wrapper" onClick={this.handleGotoDetail}>
          <div className="file-description">
            <div className="file-icon">
              <img src={getSimpleIconByName(_.get(data, 'ext', 'file'))} alt="file icon" />
            </div>
            <div className="file-info">
              <p className="details text-left" title={titleLong}>{titleShort}</p>
              <div className="top-actions">
                <div className="marks">
                {
                  Object.keys(_.get(data, 'meta.contentTags', {}))
                  .slice(0, 25) // Limit the number of tags to at most 25 for horizontal card
                  .map(key =>
                    <div key={key}>
                      <OverlayTrigger
                        placement="right-start"
                        delay={{ show: 250, hide: 400 }}
                        overlay={props => renderTooltip(props, key)}
                      >
                        <FontAwesomeIcon
                          key={key}
                          icon={faBookmark}
                          rotation={270}
                          color={_.get(data, 'meta.contentTags', {})[key].color}
                          className="mr-1 ml-1"
                          onClick={e => {
                            e.stopPropagation();
                            this.props.onTagSelect(key);
                          }}
                        />
                      </OverlayTrigger>
                      {Object.keys(_.get(data, 'meta.contentTags', {})).length < 5 && <span>{key}</span>}
                    </div>
                  )
                }
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {!isShared && <FontAwesomeIcon className="mr-2 lock-share" icon={faLock} />}
            <div className="d-flex">
              <span className="document-type">
              {Array.isArray(_.get(data, 'meta.contentType', '')) 
                ? _.get(data, 'meta.contentType', '').join(', ') 
                : _.get(data, 'meta.contentType', '')}
              </span>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div className="bottom-actions option-icon">
            <ButtonToolbar className="buttons">
              {isShared && 
                <Button
                variant="outline-danger"
                className="btn btn-outline-danger"
                size="sm"
                onClick={this.onClickShare}
                id="btnHorizontalItemCardShare"
                data-cc-analytics-on='click'
                data-cc-analytics-name='user-shorturl-copy'
                data-cc-analytics-attrs={`itemId:${data.id},shortUrl:${_.get(this.props, 'data.urls.short', '').replace('https://', '')}`}
              >
                LINK
              </Button>
              }
              { isShared && 
              <ButtonShareWithRecipient
                variant="outline-danger"
                itemId={_.get(data, "id")}
                itemShortUrl={_.get(data, "urls.short")}
                changeNotificationPermission={this.props.changeNotificationPermission}
                itemType={ShareType.Item}
                itemTitle={titleShort}
              />
              }
            </ButtonToolbar>

            <div className="rating">
              <div
                className="image-button"
                onClick={(e) => this.handleUpvote(e, _.get(this.props, 'data.id'), isAddUpvote)}
                data-cc-analytics-on='click'
                id={isAddUpvote ? 'btnUnupvoteItem' : 'btnUpvoteItem'}
                data-cc-analytics-name={isAddUpvote ? 'user-item-upvote' : 'user-item-unupvote'}
                data-cc-analytics-attrs={`itemId:${_.get(this.props, 'data.id')},name:${_.get(this.props, 'data.name', '')},userId:${_.get(this.props, 'data.userId', '')},path:/dashboard`}
              >
                <img src={isAddUpvote ? iconUpvoteOutlined : iconUpvoteFilled} alt="voted icon" />
              </div>
              <div className="dots">{_.get(data, 'meta.upvoteCount', 0)}</div>
            </div>

            <div className="stars">
              <img
                src={isFavorite ? iconFavoriteFilled: iconFavoriteOutlined}
                alt="favorite"
                className='mr-1'
                onClick={(e) => this.handleFavorite(e, _.get(this.props, 'data.id'), isFavorite)}
                data-cc-analytics-on='click'
                id={isFavorite ? 'btnUnfavoriteItem' : 'btnFavoriteItem'}
                data-cc-analytics-name={isFavorite ? 'user-item-unfavorite' : 'user-item-favorite'}
                data-cc-analytics-attrs={`itemId:${_.get(this.props, 'data.id')},name:${_.get(this.props, 'data.name', '')},userId:${_.get(this.props, 'data.userId', '')},path:/dashboard`}
              />
              <span className="star-count">{_.get(data, 'meta.favoriteCount', 0)}</span>
            </div>

            <DropdownButton
              drop="down"
              title={<FontAwesomeIcon icon={faEllipsisV} />}
              id="dropdown-button-drop-down"
              key="down"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Context Menu  */}
              {isAdmin && <Dropdown.Item eventKey="1" onClick={this.handleAddTags}><FontAwesomeIcon icon={faEdit} className="mr-2" />Tag...</Dropdown.Item>}
              {(isAdmin || isOwner) && <Dropdown.Item eventKey="1" onClick={this.handleGotoDetail}><FontAwesomeIcon icon={faEdit} className="mr-2" />Edit...</Dropdown.Item>}
              <Dropdown.Item eventKey="4" onClick={() => window.open(downloadUrl, "_blank")}><FontAwesomeIcon icon={faFileDownload} className="mr-2" />Download</Dropdown.Item>
              {(isAdmin || isOwner) && <Dropdown.Item eventKey="2" onClick={this.handleUpdateItem}><FontAwesomeIcon icon={faWrench} className="mr-2" />Update...</Dropdown.Item>}
              {(isAdmin || isOwner) && <Dropdown.Item eventKey="3" onClick={this.handleDeleteItem}><FontAwesomeIcon icon={faTrash} className="mr-2" />Delete</Dropdown.Item>}
            </DropdownButton>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  cognitoUser: state.auth.cognitoUser,
  Analytics: state.auth.Analytics,
  Auth: state.auth.Auth,
  user: state.auth.tenant
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  setItem,
  upvoteItem,
  deleteUpvoteItem,
  favoriteItem,
  deleteFavoriteItem,
  addContentTagSuccess,
  addTagToItem,
  removeTagFromItem,
  updateTagsForItems
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalItemCard);
